export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // handle error, e.g. report to a service
    console.log('nuxtApp/vueApp error occurred: ', error)
  }

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    const isExtraneousAttrsWarning = msg.startsWith('Extraneous non-props attributes (')
    //console.log('warning: ', msg.substring(0,50), isExtraneousAttrsWarning)
    const builderProps = ['builderBlock', 'builderContext', 'linkComponent', 'lockAspectRatio', 'height', 'width', 'target']

    // ignore warnings for builder props
    if (isExtraneousAttrsWarning && builderProps.some(prop => msg.includes(prop))) {
      return
    }
    console.warn('[Vue warn]', msg, trace)
  }

  // Also possible
  nuxtApp.hook('vue:error', (error, instance, info) => {
    // handle error, e.g. report to a service
    console.log('vue:error error occurred: ', error)
  })

  nuxtApp.hook('app:error', (error) => {
    /* your code goes here */
    console.log('app:error error occurred: ', error)
  })
})
